import { ICommonsRepository } from './../../repositories/commons_repository';
import { ICreateClienteSimplificadoUseCase } from "../../../presentation/useCases/create/create_cliente_simplificado_use_case";
import { ClienteSimplificadoForm } from '../../../presentation/schemas/ClienteSimplificado';

/**
 * CreateClienteSimplificadoUseCaseUseCase
 */

export class CreateClienteSimplificadoUseCase implements ICreateClienteSimplificadoUseCase {
  constructor(private readonly repository: ICommonsRepository) { }

  async createClienteSimplificado(form: ClienteSimplificadoForm): Promise<number> {
    return this.repository.createClienteSimplificado({
      ...form,
      dataNascimento: form.dataNascimento != null ? form.dataNascimento : new Date("0001-01-01T00:00:00")
    });

  }


}
